/**
 * Product View
 */
class ProductView {

	constructor(presenter) {

		this.presenter = presenter;
		this.form = $("#cart-form");
		this.input = this.form.find("input");
		this.submit = this.form.find(":submit");
		this.disabledVariantLabels = new Array();
		this.licenseModalCCBYNCND = new bootstrap.Modal("#creative-commons-byncnd-modal");
		this.licenseModalCCBYNCNDCheckBox = $("#creative-commons-byncnd-modal input.form-check-input");
		this.licenseModalCCBYNCNDAddToCart = $("#creative-commons-byncnd-modal button.add-to-cart");

		/*
		 * Listeners
		 */

		this.form.on("submit", $.proxy(function(event) {
			
			// we handle the form submission via ajax, so cancel the submit event
			event.preventDefault();
			event.stopPropagation();

			// validate the form
			var result = this.validateForm();
			if (result === true) {
				
				// the form is okay, so call for the cart to be updated
				const formData = new FormData(this.form.get(0));
				
				// check if we need to display license info
				if (formData.has("license") && formData.get("license") === "CC BY-NC-ND") {
					this.licenseModalCCBYNCND.show();
				}
				else {
					this.submit.prop("disabled", true);
					this.presenter.updateCart(formData);	
				}
				
			}

		}, this));

		this.input.on("click", $.proxy(function(_event) {
			// simply validate the form, as this will update the form user interface
			this.validateForm();
		}, this));

		$("#creative-commons-byncnd-modal").on("show.bs.modal", $.proxy(function(_event) {
			// when showing the modal, make user the interface is reset
			this.licenseModalCCBYNCNDCheckBox.prop("checked", false);
			this.licenseModalCCBYNCNDAddToCart.prop("disabled", true);
		}, this));

		this.licenseModalCCBYNCNDCheckBox.on("click", $.proxy(function(_event) {
			// enable/disable the modal add-to-cart button
			if (this.licenseModalCCBYNCNDCheckBox.prop("checked") === true) {
				this.licenseModalCCBYNCNDAddToCart.prop("disabled", false);
			}
			else {
				this.licenseModalCCBYNCNDAddToCart.prop("disabled", true);
			}
		}, this));

		this.licenseModalCCBYNCNDAddToCart.on("click", $.proxy(function(_event) {
			// get the form data and update the cart
			const formData = new FormData(this.form.get(0));
			this.submit.prop("disabled", true);
			this.presenter.updateCart(formData);
			// hide the modal
			this.licenseModalCCBYNCND.hide();
		}, this));

	}


	/*
	 * Actions
	 */

	validateForm() {

		// check whether this form is valid
		var result = this.form.get(0).checkValidity();
		if (result === false) {
			// for any validation feedback elements, show their error message
			this.form.find("input.validation-feedback:invalid").each(function() {
				var feedback = $(this).closest("div.validation-feedback").next("div.validation-feedback");
				feedback.removeClass("d-none").addClass("d-block");
			});
		}

        // for any validation feedback elements that do not have an error, clear the error message
		this.form.find("input.validation-feedback:valid").each(function() {
			var feedback = $(this).closest("div.validation-feedback").next("div.validation-feedback");
			feedback.removeClass("d-block").addClass("d-none");
		});

		this.form.addClass("was-validated");

		return result;

	}

	resetForm() {
		// reset the form
		this.form.trigger("reset");
		this.submit.prop("disabled", false);
	}

	checkCart(cart) {

		// iterate over any previously disabled variants and re-enable them, then reset the array that tracks this
		for (var i = 0; i < this.disabledVariantLabels.length; i++) {
			this.disabledVariantLabels[i].removeClass("disabled");
		}
		this.disabledVariantLabels = new Array();

		// iterate over the items in the cart
		const items = cart.items;
		for (var i = 0; i < items.length; i++) {

			// items in the cart that have zero value after being discounted can only have a quantity of one, so disable the relevant variant button
			if (items[i].discounted_price == 0) {
				// get the variant label for this cart item
				const variantId = items[i].id;
				const variantInput = this.form.find("input[value='" + variantId + "']");
				const variantLabel = this.form.find("label[for='" + variantInput.attr("id") + "']");
				// we do not want to handle and track labels that are already disabled
				if (variantLabel.hasClass("disabled") == false) {
					// disable this variant label, and then track we have done this by adding it to the list of disabled labels
					variantLabel.addClass("disabled");
					this.disabledVariantLabels.push(variantLabel);
				}

			}		

		}

	}

}